import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBaLogoFullWhite = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Layer_1",
	"data-name": "Layer 1",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 595.28 230.14",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: "\n      .cls-1 {\n        fill: #fff;\n      }\n    " }) }),
		/* @__PURE__ */ _jsx("polygon", {
			className: "cls-1",
			points: "3.34 224.33 3.34 5.81 221.74 5.81 221.74 71.07 210.3 71.07 210.27 16.76 14.29 16.76 14.29 213.38 210.27 213.38 210.27 156.17 221.74 156.17 221.74 224.33 3.34 224.33"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-1",
			d: "M80.86,121.47a14.18,14.18,0,0,1,3.11,9,14.45,14.45,0,0,1-2.26,8.06A14.92,14.92,0,0,1,75.2,144a23.87,23.87,0,0,1-10.07,2H40.47V88.79H64.06a24.61,24.61,0,0,1,10,1.88,14.35,14.35,0,0,1,6.39,5.25,13.76,13.76,0,0,1,2.17,7.61A13,13,0,0,1,80,111.89a14.2,14.2,0,0,1-7.08,4.75A12.88,12.88,0,0,1,80.86,121.47Zm-28.92-9.09H62.42a9.59,9.59,0,0,0,6.31-1.84,6.48,6.48,0,0,0,2.21-5.29,6.59,6.59,0,0,0-2.21-5.32,9.43,9.43,0,0,0-6.31-1.88H51.94ZM70,134.66a6.86,6.86,0,0,0,2.34-5.57,7.15,7.15,0,0,0-2.46-5.77,9.88,9.88,0,0,0-6.64-2.09H51.94v15.4H63.49A9.83,9.83,0,0,0,70,134.66Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-1",
			d: "M102.81,85.35V146H91.34V85.35Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-1",
			d: "M120.67,143.8a21,21,0,0,1-8.24-8.24,24.68,24.68,0,0,1-3-12.28A24.14,24.14,0,0,1,112.52,111a21.21,21.21,0,0,1,8.39-8.23,25.7,25.7,0,0,1,23.76,0,21.21,21.21,0,0,1,8.39,8.23,24.14,24.14,0,0,1,3.08,12.29A23.66,23.66,0,0,1,153,135.56a21.83,21.83,0,0,1-8.52,8.24,24.72,24.72,0,0,1-12,2.91A23.85,23.85,0,0,1,120.67,143.8Zm17.65-8.6a11,11,0,0,0,4.38-4.55,15.35,15.35,0,0,0,1.64-7.37c0-4.32-1.13-7.63-3.4-10a11.18,11.18,0,0,0-8.31-3.48,10.94,10.94,0,0,0-8.24,3.48c-2.21,2.33-3.31,5.64-3.31,10s1.07,7.63,3.23,9.95a10.67,10.67,0,0,0,8.15,3.48A11.93,11.93,0,0,0,138.32,135.2Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-1",
			d: "M162.69,111a20.36,20.36,0,0,1,7.95-8.19,23,23,0,0,1,11.63-2.91q8.43,0,14,4.22a20.5,20.5,0,0,1,7.42,11.83H191.28a9.06,9.06,0,0,0-3.32-4.62,9.63,9.63,0,0,0-5.77-1.68,9.45,9.45,0,0,0-7.79,3.56q-2.86,3.56-2.86,10.12t2.86,10a9.45,9.45,0,0,0,7.79,3.56q7,0,9.09-6.22h12.37a20.92,20.92,0,0,1-7.46,11.71q-5.56,4.35-13.92,4.35a23,23,0,0,1-11.63-2.91,20.45,20.45,0,0,1-7.95-8.2,27.9,27.9,0,0,1,0-24.65Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-1",
			d: "M237.15,146l-15.4-19.34V146H210.28V85.35h11.47v34.49L237,100.58H251.9l-20,22.78L252.06,146Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-1",
			d: "M285.45,90l-20.69,56h6l4.95-13.47h25.81l5,13.47h6L291.86,90Zm-8,37.82,11.2-30.68,11.2,30.68Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-1",
			d: "M341.73,100.85a18.58,18.58,0,0,0-9,2.16,14.44,14.44,0,0,0-6.08,6.2v-7.54H321V146h5.68V121.79q0-7.87,3.81-11.93a13.38,13.38,0,0,1,10.23-4.06q6.24,0,9.86,3.82t3.61,11V146h5.6V120q0-9.35-5-14.25T341.73,100.85Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-1",
			d: "M406.94,111.4a17,17,0,0,0-6.61-7.46A19.88,19.88,0,0,0,389.41,101a21.28,21.28,0,0,0-10.91,2.8,19.38,19.38,0,0,0-7.55,8,25.28,25.28,0,0,0-2.72,12,25.56,25.56,0,0,0,2.72,12,19.65,19.65,0,0,0,7.55,8,20.88,20.88,0,0,0,10.83,2.84,19.68,19.68,0,0,0,10.91-3,17.79,17.79,0,0,0,6.7-7.51V146h5.68v-44.3h-5.68Zm-2.19,21.83a15.58,15.58,0,0,1-6,6.25,16.25,16.25,0,0,1-8.31,2.19,16.61,16.61,0,0,1-8.44-2.15,15.09,15.09,0,0,1-5.89-6.25,20.26,20.26,0,0,1-2.15-9.53,20,20,0,0,1,2.15-9.54,15,15,0,0,1,5.89-6.12,16.79,16.79,0,0,1,8.44-2.11,16.25,16.25,0,0,1,8.31,2.19,15.58,15.58,0,0,1,6,6.25,21.31,21.31,0,0,1,0,18.82Z"
		}),
		/* @__PURE__ */ _jsx("rect", {
			className: "cls-1",
			x: 420.96,
			y: 85.92,
			width: 5.68,
			height: 60.05
		}),
		/* @__PURE__ */ _jsx("rect", {
			className: "cls-1",
			x: 437.97,
			y: 101.67,
			width: 5.68,
			height: 44.31
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-1",
			d: "M440.81,85a4,4,0,0,0-2.92,1.18,3.94,3.94,0,0,0-1.22,3,4.08,4.08,0,0,0,1.22,3,4.1,4.1,0,0,0,5.84,0,4,4,0,0,0,1.22-3,3.91,3.91,0,0,0-1.22-3A4,4,0,0,0,440.81,85Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-1",
			d: "M464,90.55h-5.76v11.12h-6.17v4.78h6.17V134q0,6.42,2.92,9.21t8.92,2.8h6.09V141.1H471q-3.9,0-5.44-1.54c-1-1-1.54-2.89-1.54-5.6V106.45h12.17v-4.78H464Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-1",
			d: "M488.71,85a4,4,0,0,0-2.92,1.18,3.91,3.91,0,0,0-1.22,3,4,4,0,0,0,1.22,3,4.1,4.1,0,0,0,5.84,0,4.08,4.08,0,0,0,1.22-3,3.94,3.94,0,0,0-1.22-3A4,4,0,0,0,488.71,85Z"
		}),
		/* @__PURE__ */ _jsx("rect", {
			className: "cls-1",
			x: 485.87,
			y: 101.67,
			width: 5.68,
			height: 44.31
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-1",
			d: "M512.62,107.91a16,16,0,0,1,8-2A15.62,15.62,0,0,1,530,108.6a12.49,12.49,0,0,1,4.91,7.51H541a18.43,18.43,0,0,0-6.86-11q-5.31-4-13.51-4a21.87,21.87,0,0,0-11.12,2.8,19.63,19.63,0,0,0-7.63,8,27.78,27.78,0,0,0,0,24.1,19.63,19.63,0,0,0,7.63,7.95,21.87,21.87,0,0,0,11.12,2.8q8.11,0,13.47-4.14a18.6,18.6,0,0,0,6.9-10.95h-6.09a12.48,12.48,0,0,1-4.91,7.58,15.55,15.55,0,0,1-9.37,2.72,16,16,0,0,1-8-2,14.27,14.27,0,0,1-5.64-6.09,21.63,21.63,0,0,1-2.07-9.9A21.34,21.34,0,0,1,507,114,14.27,14.27,0,0,1,512.62,107.91Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-1",
			d: "M586.26,101.67v9.73a17,17,0,0,0-6.62-7.46A19.83,19.83,0,0,0,568.73,101a21.28,21.28,0,0,0-10.91,2.8,19.38,19.38,0,0,0-7.55,8,25.28,25.28,0,0,0-2.72,12,25.56,25.56,0,0,0,2.72,12,19.65,19.65,0,0,0,7.55,8,20.88,20.88,0,0,0,10.83,2.84,19.68,19.68,0,0,0,10.91-3,17.79,17.79,0,0,0,6.7-7.51V146h5.68v-44.3Zm-2.19,31.56a15.58,15.58,0,0,1-6,6.25,16.25,16.25,0,0,1-8.31,2.19,16.61,16.61,0,0,1-8.44-2.15,15.09,15.09,0,0,1-5.89-6.25,20.26,20.26,0,0,1-2.15-9.53,20,20,0,0,1,2.15-9.54,15,15,0,0,1,5.89-6.12,16.79,16.79,0,0,1,8.44-2.11,16.25,16.25,0,0,1,8.31,2.19,15.58,15.58,0,0,1,6,6.25,21.31,21.31,0,0,1,0,18.82Z"
		})
	]
});
export default SvgBaLogoFullWhite;
